import * as React from "react";
import { Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha";
import SortIcon from "@mui/icons-material/Sort";
import { SortDirection } from "generated/graphql";

export default function SearchAndSortFiles({
  query,
  sortBy,
  sortDirection,
  handleInputChange,
  handleSortChange,
}: {
  query: string;
  sortBy: string;
  sortDirection: SortDirection;
  handleInputChange: (e: any) => void;
  handleSortChange: (c: string) => void;
}) {
  const iconButtonSx = {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    padding: 0,
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  };

  return (
    <MDBox
      textAlign="right"
      display="flex"
      alignItems="center"
      flexWrap="nowrap"
      gap={1}
      sx={{ minWidth: 0 }}
    >
      <MDInput
        label={"Search"}
        variant="standard"
        size="small"
        value={query}
        onChange={handleInputChange}
        sx={{ minWidth: "180px" }}
      />
      <MDBox display="flex" alignItems="center" gap={0.5} flexWrap="nowrap" pl={1}>
        <Tooltip title="Sort by name">
          <MDButton iconOnly onClick={() => handleSortChange("name")} sx={iconButtonSx}>
            {sortBy === "name" ? (sortDirection === SortDirection.ASC ? "↑" : "↓") : ""}
            <SortByAlphaIcon />
          </MDButton>
        </Tooltip>
        <Tooltip title="Sort by date">
          <MDButton iconOnly onClick={() => handleSortChange("createdAt")} sx={iconButtonSx}>
            {sortBy === "created_at" ? (sortDirection === SortDirection.ASC ? "↑" : "↓") : ""}
            <SortIcon />
          </MDButton>
        </Tooltip>
      </MDBox>
    </MDBox>
  );
}
